import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/ibm-aiops-training/ibm-aiops-training/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineNotification = makeShortcode("InlineNotification");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`📥 STEP: Open ELK`}</h2>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`In your OpenShift Console click on the Applications Menu`}</p>
        <img parentName="li" {...{
          "src": "./../images/14_elk.png",
          "alt": "image"
        }}></img>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Select `}<strong parentName="p">{`Logging`}</strong></p>
      </li>
    </ol>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Click `}<inlineCode parentName="p">{`Allow selected permissions`}</inlineCode></p>
        <img parentName="li" {...{
          "src": "./../images/14_elk_2.png",
          "alt": "image"
        }}></img>
      </li>
    </ol>
    <h2>{`📥 STEP: Initialize ELK`}</h2>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Input `}<inlineCode parentName="p">{`app*`}</inlineCode>{` for the index pattern`}</p>
        <img parentName="li" {...{
          "src": "./../images/15_elk.png",
          "alt": "image"
        }}></img>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click `}<inlineCode parentName="p">{`Next Step`}</inlineCode></p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Select `}<inlineCode parentName="p">{`@timestamp`}</inlineCode>{` for the Time Filter`}</p>
        <img parentName="li" {...{
          "src": "./../images/16_elk.png",
          "alt": "image"
        }}></img>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click `}<inlineCode parentName="p">{`Create Index Pattern`}</inlineCode></p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click on `}<inlineCode parentName="p">{`Discover`}</inlineCode></p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`ELK is now configured. Verify that you have Logs coming in.`}</p>
        <img parentName="li" {...{
          "src": "./../images/17_elk.png",
          "alt": "image"
        }}></img>
      </li>
    </ol>
    <InlineNotification kind="success" mdxType="InlineNotification">
      <p><strong parentName="p">{`You have successfully finished this Chapter`}</strong></p>
      <p>{`You are now done with the chapter on creating Training Resources.`}</p>
      <p>{`Please continue to the next chapter to learn how to Configure CP4AIOPS.`}</p>
    </InlineNotification>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      